import { cn } from '@/lib/utils'
import { GeneralInformation } from '@/types/typo3/sections/spotsanity-reports'
import { Button, Richtext } from '@/ui/components'

interface Props {
  data: GeneralInformation[]
}

const InfoComponent = ({ data }: Props) => (
  <div className={''}>
    {data.map((item, i) => (
      <div key={i?.toString()}>
        {item.title && <h3 className="h4 mb-md">{item.title}</h3>}
        {item.description && (
          <Richtext text={item.description.replace(/\n/g, '<br>') as string} />
        )}
        {item.links && item.links.href && item.title && (
          <Button
            className={cn('', 'mt-md')}
            key={i?.toString()}
            variant="secondary"
            href={item.links.href}
            target={item.links.target}
            nextLink={item.links.target !== '_blank' ? true : false}
            isTransition={item.links.target !== '_blank' ? true : false}
          >
            {item.links.title}
          </Button>
        )}
      </div>
    ))}
  </div>
)

export default InfoComponent
